import {ref, getCurrentInstance} from "vue";

import Configuration from "@/configuration";

export default function useTools() {
    const {proxy} = getCurrentInstance();

    const $i18n = proxy.$i18n;
    const $router = proxy.$router;
    const $route = proxy.$route;
    const $swal = proxy.$swal;
    const $refs = proxy.$refs;
    const $moment = proxy.$moment;
    const $emit = proxy.$emit;
    const $vuetify = proxy.$vuetify;

    const $apiUrl = ref(Configuration.value("rootApi"));
    // const api_url = ref('http://localhost:3002/api');


    return {
        $swal,
        $router,
        $route,
        $i18n,
        $apiUrl,
        $refs,
        $moment,
        $emit,
        $vuetify,
    };
}
